import { ISectionLink } from 'core/model/interfaces/static-page.interface';
import type { TSliceReducer } from 'core/store';
import { IStaticPagesState } from './types';

export const updateSections: TSliceReducer<IStaticPagesState, Array<ISectionLink>> = (state, action) => {
  state.sections.data = action.payload;
};

export const clearSections: TSliceReducer<IStaticPagesState> = state => {
  state.sections.data = [];
};

export const reducers = {
  clearSections,
  updateSections,
};
